"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/7f4f04da-1315-4a67-baa3-59af36699f1c
 * name: IcClockCheckMiddle
 */
function IcClockCheckMiddle() {
    return null;
}
exports.default = IcClockCheckMiddle;
;
